module.exports = __webpack_public_path__ + "assets/img/126101.7713eed2.svg";